// extracted by mini-css-extract-plugin
export var label = "_cn-5";
export var slideContainer = "_cn-0";
export var slider = "_cn-1";
export var sliderLg = "_cn-4";
export var sliderMd = "_cn-3";
export var sliderSm = "_cn-2";